import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fileSize', standalone: false })
export class FileSizePipe implements PipeTransform {
  transform(value: number | string | null | undefined, digits: number = 1): string {
    const bytes = typeof value === 'number' ? value : parseInt(String(value || 0), 10) || 0;
    if (!bytes || bytes <= 0) return `0 KB`;
    const KB = 1024;
    const MB = KB * 1024;
    if (bytes < MB) {
      const kb = bytes / KB;
      return `${kb.toFixed(digits)} KB`;
    }
    const mb = bytes / MB;
    return `${mb.toFixed(digits)} MB`;
  }
}
